import React, { FC, useContext, useState } from 'react';
import { useLocation, Link, useHistory } from 'react-router-dom';
import { makeStyles, Box } from '@material-ui/core';

import Icon from 'src/components/Icon';
import { WorkspaceProps, STATIC_WORKSPACE } from 'src/constants/layouts';
import ChevronLeft from 'src/components/Icon/ChevronLeft';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import GuestModal from 'src/components/Modal/GuestModal';
import { colors } from 'src/constants/theme/colors';
import { transitions } from 'src/constants/theme/transitions';
import { radius } from 'src/constants/theme/radius';

const useStyles = makeStyles(() => ({
  wrapper: {
    maxWidth: 185,
    minWidth: 185,
    height: '100%',
    background: colors.background.primary,
    zIndex: 999,
    transition: transitions.default,
    borderRight: `1px solid ${colors.border.default}`
  },
  offWrapper: {
    maxWidth: 67,
    minWidth: 67,
    height: '100%',
    zIndex: 999,
    background: colors.background.primary,
    transition: transitions.default,
    borderRight: `1px solid ${colors.border.default}`
  },
  logo: {
    width: 64,
    height: 28,
    margin: '32px 80px 128px 48px'
  },

  navBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 8px'
  },
  navMenu: {
    width: '100%',
    marginBottom: 4,
    padding: '12px 16px',
    borderRadius: radius.sm,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    background: 'none',
    transition: transitions.default,
    '&:hover': {
      backgroundColor: colors.background.tertiary
    }
  },
  navText: {
    marginLeft: 12,
    color: colors.text.secondary,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 500
  }
}));

const UiNavLeft: FC<{
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ visible, setVisible }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { authStatus } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const isBillingPage = location.pathname.includes('/billing');

  const onClickArrowBack = () => {
    history.push('/workspace/draft');
  };
  const onClickGuestModal = () => {
    setShowModal(prev => !prev);
  };
  const content = visible ? (
    <Box className={classes.wrapper}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingTop: '25px',
          paddingRight: '15px',
          height: 70,
          width: '100%'
        }}
      >
        <div style={{ cursor: 'pointer' }} onClick={() => setVisible(false)}>
          <ChevronLeft />
        </div>
      </div>
      <Box className={classes.navBox}>
        {STATIC_WORKSPACE.map((routes: WorkspaceProps) => {
          const ACTION = location.pathname === routes.id;
          return (
            <Link
              key={routes.id}
              to={routes.id}
              onClick={e => {
                if (
                  authStatus !== AuthStatus.SignedIn &&
                  routes.route === 'DRAFT'
                ) {
                  e.preventDefault();
                  onClickGuestModal();
                }
              }}
              className={classes.navMenu}
            >
              <Icon
                size={24}
                icon={routes.icon}
                style={{ opacity: ACTION ? 1 : 0.6 }}
              />
              <span
                className={classes.navText}
                style={
                  ACTION
                    ? {
                        color: colors.text.primary,
                        fontWeight: 600
                      }
                    : { color: colors.text.tertiary, fontWeight: 500 }
                }
              >
                {routes.route}
              </span>
            </Link>
          );
        })}
      </Box>
      {showModal && <GuestModal onClickGuestModal={onClickGuestModal} />}
    </Box>
  ) : (
    <Box className={classes.offWrapper}>
      {isBillingPage ? (
        <ArrowBackIcon
          onClick={onClickArrowBack}
          style={{ margin: '20px 0 0 20px', cursor: 'pointer' }}
        />
      ) : (
        <MenuIcon
          onClick={() => setVisible(true)}
          style={{ margin: '20px 0 0 20px', cursor: 'pointer' }}
        />
      )}
    </Box>
  );

  return <>{content}</>;
};

export default UiNavLeft;
